(function () {

    angular
        .module('app.auth')
        .controller('LoginCtrl', login)

    login.$inject = ['$auth', '$location', '$rootScope', 'utils', 'AuthFactory', 'md5']
    function login($auth, $location, $rootScope, utils, factory, md5) {
        var self = this
        self.login = login
        self.user = {}
        // init
        init()

        function init() {
            utils.hideLoader()
        }

        /// login ////
        function login() {
            // show loader
            utils.showLoader()
	    // encrypt password
            // create deep copy for user object so the password is not replaced in front-end
            var _user = angular.copy(self.user)
            _user.password = md5.createHash(self.user.password)
            // make request
            factory.login(_user, function (error, token) {
                // hide loader
                utils.hideLoader()
                // handle response

                if (error)
                    utils.showError(error.data.message)
                else {
                    $auth.setToken(token)
                    $location.path('/transcriber/')
                }

            })
        }

    }
})();

